import React, { forwardRef } from 'react';
import { Button } from 'ssc-ui-react';

import { $gt } from '@/common/appCtx';

import { BatchImportSummary } from '../../type';
import BatchImportButton from '../batch-import-button';
import style from './index.module.less';

interface MassActionsProps {
  onDownloadTemplate?: () => void;
  onImport?: () => void;
  onDownloadRes?: () => void;
  title?: string;
  summary?: BatchImportSummary;
  batchImportButtonProps: any;
}

export const MassActions = forwardRef((props: MassActionsProps, ref: any) => {
  const { title, summary, onDownloadTemplate, batchImportButtonProps, onDownloadRes } = props;
  return <div className={style.actionsArea}>
    <div className={style.actionsAreaTitle}>
      <div className={style.title}>
        { $gt(title ?? '-') }
      </div>
      <div className={style.detailAccount}>
        <span className="border-item">{ $gt('Total Item') }: { summary?.total_cnt ?? '-' }</span>
        <span className="border-item">{ $gt('Succeeded') }: { summary?.success_cnt ?? '-' }</span>
        <span>{ $gt('Failed') }: { summary?.fail_cnt ?? '-' }</span>
      </div>
    </div>
    <div className={style.operationButton}>
      <Button onClick={onDownloadRes} className={style.downloadButton}>
        { $gt('Download Result') }
      </Button>
      <Button onClick={onDownloadTemplate} className={style.downloadButton}>
        { $gt('Download Template') }
      </Button>
      <BatchImportButton {...batchImportButtonProps} text={$gt('Import')} ref={ref} />
    </div>
  </div>;
});
